import { useEffect, useState } from 'react';

/** App.tsx's shell breakpoint. */
const MOBILE = '(max-width: 767px)';

/**
 * True while the viewport is at or below the app shell's mobile breakpoint.
 *
 * Copy of hooks/useNarrow.ts rather than a shared parameterised hook: that
 * one answers a Tailwind `sm` question (does a placeholder fit), this one
 * answers App.tsx's own 768px shell question (does the guided tour run at
 * all) — different numbers for different reasons, and coupling them would
 * make a future change to one silently change the other.
 *
 * Guarded for jsdom, which has no `matchMedia`: tests get `false` and the
 * full string, rather than a crash on mount.
 */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MOBILE).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(MOBILE);
    const onChange = (e: MediaQueryListEvent) => setMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile;
}

export default useIsMobile;
